var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12801 19.9998H6.35596C5.6071 19.9998 5 19.3927 5 18.6439V5.35592C5 4.60708 5.6071 4 6.35596 4H12.8646C13.239 4 13.578 4.15176 13.8234 4.39715L15.1793 5.75306C15.4247 5.99842 15.5765 6.3374 15.5765 6.71183V10.4467",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6837 11.1723C19.2132 10.6428 20.0718 10.6428 20.6013 11.1723C21.1308 11.7018 21.1308 12.5603 20.6013 13.0899L14.9968 18.6942C14.8985 18.7925 14.7857 18.8751 14.6623 18.9391L12.7636 19.924C12.5082 20.0564 12.1863 20.0155 11.972 19.8013C11.7578 19.5871 11.7169 19.2651 11.8493 19.0098L12.8343 17.1111C12.8983 16.9877 12.9809 16.8749 13.0791 16.7767L18.6837 11.1723Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71094 9.15259H12.8636",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71094 11.8643H12.8636",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71094 14.5762H10.1517",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInput);
export default __webpack_public_path__ + "static/media/Input.f89432612219aa8be15d1de4ed167ae9.svg";
export { ForwardRef as ReactComponent };